'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _appBadges = require('../../../atoms/app-badges');

var _appBadges2 = _interopRequireDefault(_appBadges);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'info-hero';

var InformationalHero = function (_React$Component) {
  _inherits(InformationalHero, _React$Component);

  function InformationalHero() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InformationalHero);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InformationalHero.__proto__ || Object.getPrototypeOf(InformationalHero)).call.apply(_ref, [this].concat(args))), _this), _this.getAlignment = function (textAlign) {
      var alignment = {
        left: ORGANISM_NAME + '__container col-xs-12 col-lg-8 text-xs-left',
        center: ORGANISM_NAME + '__container col-xs-12 col-lg-8 center-block text-xs-center'
      };
      return alignment[textAlign || 'center'];
    }, _this.renderParagraph = function (paragraph) {
      if (paragraph && paragraph.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    }, _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: 2, className: ORGANISM_NAME + '__headline' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    }, _this.renderCta = function (cta, ctaClasses) {
      if (cta && cta.text) {
        var targetValue = cta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            color: cta.color || null,
            className: ctaClasses,
            fpti: 'InfoHero-' + (cta.type || 'cta') + '-' + (cta.fpti || cta.text),
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    }, _this.renderHatchText = function (hatchText) {
      if (hatchText && hatchText.text) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__hatch-text pp-sans-small-regular' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InformationalHero, [{
    key: 'renderBadge',
    value: function renderBadge(clientInfo, isCentered) {
      var appBadgeContent = {
        clientInfo: clientInfo,
        ios: this.props.content.ios,
        android: this.props.content.android
      };
      var classes = isCentered ? ORGANISM_NAME + '__app-badge-wrapper--center' : ORGANISM_NAME + '__app-badge-wrapper';

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(_appBadges2.default, appBadgeContent)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.props.config.theme || 'theme-background-color-white';
      var newProps = (0, _themeManager2.default)({ content: this.props.content }, theme);
      var content = newProps.content;
      var _props = this.props,
          config = _props.config,
          className = _props.className,
          viewport = _props.viewport,
          clientInfo = _props.clientInfo;
      var headline = content.headline,
          paragraph = content.paragraph,
          primaryCta = content.primaryCta,
          hatchText = content.hatchText;


      var heroClasses = (0, _classnames2.default)(ORGANISM_NAME, theme, className);

      var backgroundImage = config.backgroundImage && (config.backgroundImage[viewport] || config.backgroundImage.url);
      var backgroundPosition = config.backgroundImage && config.backgroundPosition;
      var backgroundImageStyle = backgroundImage ? {
        backgroundImage: 'url(' + backgroundImage + ')',
        backgroundPosition: '' + (backgroundPosition || 'center')
      } : null;

      var ctaClasses = (0, _classnames2.default)(ORGANISM_NAME + '__cta', _defineProperty({}, ORGANISM_NAME + '__cta--center', config.textAlign !== 'left'));

      var isCentered = config.deviceImageSize === 'large';

      return _react2.default.createElement(
        'section',
        {
          id: config.id ? config.id : null,
          'data-building-block': 'organism',
          className: heroClasses,
          style: backgroundImageStyle
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: this.getAlignment(config.textAlign) },
              this.renderHeadline(headline),
              this.renderParagraph(paragraph),
              this.renderCta(primaryCta, ctaClasses),
              this.renderBadge(clientInfo, isCentered),
              this.renderHatchText(hatchText)
            )
          )
        )
      );
    }
  }]);

  return InformationalHero;
}(_react2.default.Component);

exports.default = InformationalHero;


InformationalHero.propTypes = {
  viewport: _propTypes2.default.string,
  clientInfo: _propTypes2.default.shape({
    client_os_type: _propTypes2.default.string,
    client_is_mobile: _propTypes2.default.bool,
    client_type: _propTypes2.default.string
  }),
  config: _propTypes2.default.shape({
    backgroundImage: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      portable: _propTypes2.default.string.isRequired,
      mobile: _propTypes2.default.string.isRequired
    }),
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-dark', 'theme-background-image-dark', 'theme-background-image-light']),
    backgroundPosition: _propTypes2.default.oneOf(['left', 'center', 'right']),
    textAlign: _propTypes2.default.oneOf(['center', 'left']),
    id: _propTypes2.default.string // visible
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    ios: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    }),
    android: _propTypes2.default.shape({
      store: _propTypes2.default.oneOf(['google', 'android-store']),
      href: _propTypes2.default.string.isRequired,
      fpti: _propTypes2.default.string
    })
  }),
  className: _propTypes2.default.string
};

InformationalHero.defaultProps = {
  viewport: 'dedicated',
  clientInfo: {
    client_os_type: 'ios',
    client_is_mobile: true,
    client_type: 'dedicated'
  },
  config: {
    theme: 'theme-background-color-white',
    backgroundImage: {
      url: '',
      portable: '',
      mobile: ''
    },
    backgroundPosition: 'center',
    textAlign: 'center',
    id: ''
  },
  content: {
    headline: {
      text: '21 characters per line - 2 lines maximum.'
    },
    paragraph: {
      text: 'In mobile and tablet views, align text to optimize contrast ' + 'with background image. 152 characters maximum.'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    },
    ios: {
      href: 'https://app.adjust.com/vlx5gy',
      fpti: 'informational-hero'
    },
    android: {
      store: 'google',
      href: 'https://app.adjust.com/vxullh',
      fpti: 'informational-hero'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/informational-hero/jsx/InformationalHero.js
// module id = 1107
// module chunks = 4